import Flex from 'components/ui/Flex';
import Text from 'components/ui/Text';
import useAppSelector from 'hooks/useAppSelector';
import { Col } from 'reactstrap';
import styled from 'styled-components/macro';
import Products from './Products';
import { selectShowHero } from 'store/reducers/shopSlice';

const Home = () => {
    const { shop } = useAppSelector(({ shop }) => shop);
    const showHero = useAppSelector(selectShowHero);

    return (
        <>
            <Col lg="5" sm="8" className="mx-auto justify-content-center">
                <Flex className="mb-4 p-4 d-flex align-items-center justify-content-center" column>
                    {!showHero && <Header className="display-2">{shop?.selectedUnit?.name ?? shop?.name}</Header>}

                    <Text light className="h2 preformatted text-break">
                        {shop?.description}
                    </Text>

                    <Text light className="h3  text-break">
                        {shop?.bodyText}
                    </Text>
                </Flex>
            </Col>
            <Products />
        </>
    );
};

const Header = styled.h1`
    font-size: 32px;
`;
export default Home;
